import {
  FormControl as MaterialFormControl,
  RadioGroup as MaterialRadioGroup,
  FormControlLabel as MaterialFormControlLabel,
} from '@material-ui/core';
import styled, { css, createGlobalStyle } from 'styled-components';

import {
  HeaderTitle as SidesheetHeader,
  HeaderContainer as SidesheetHeaderContainer,
} from '~/components/Sidesheet/styles';
import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const SidesheetCustomStyle = createGlobalStyle<any>`

  ${SidesheetHeaderContainer} {
    height: 4.5rem;
  }

    ${SidesheetHeader} {
      margin: 1.7rem 1.1rem 0 1.1rem;
     h3 {
       font-size: 32px;
       color: ${colors.lightblack}
     }
    }
`;

export const Container = styled.div``;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FilterWrapper = styled.div`
  display: flex;
  gap: ${grid.sm};
  align-items: center;
  justify-content: flex-end;
  margin-right: 0.5rem;
  margin-top: -0.8rem;
  height: 3.5rem;
  float: right;
  width: 500px;
`;

export const FilterTitle = styled.p`
  margin: 2.8rem 0 0 0;
  font-size: 14px;
  color: #4d4d4d;
`;

export const SubmitFilterButton = styled.button`
  width: 29.8rem;
  height: 2.8rem;
  border-radius: 5px;
  font-weight: bold;
  border: none;
  background-color: ${colors.primary};
  color: white;
  margin-top: auto;
  align-self: bottom;
`;

export const FilterButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.2rem;
  height: 2.8rem;
  color: white;
  border-radius: 5px;
  border: none;
  background: ${colors.primary};
`;

export const FormControl = styled(MaterialFormControl)`
  margin-bottom: 2.4rem !important;
`;

export const RadioGroup = styled(MaterialRadioGroup)``;

export const FormControlLabel = styled(MaterialFormControlLabel)`
  height: 1.5rem;
  border-radius: 11px;
  margin-left: 0px !important;
  padding: 0.2rem 1.1rem;
  font-size: 12px;
  transition: color 0.5s;
  transition: background-color 0.5s;
  transition: ease-in 0.2s;

  ${(props) =>
    props.checked &&
    css`
      background-color: ${colors.primary};
      color: ${colors.white};
    `}

  ${(props) =>
    !props.checked &&
    css`
      color: #4d4d4d;
      background-color: transparent;
      border: 1px solid #eb0045;
    `}


  & span:first-child {
    display: none;
  }
`;

export const ContentFooter = styled.div`
  margin-top: 1.4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
